import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import TimeModal from '../../common/TimeModal'

import * as Strings from './strings'
import * as configActions from '../../actions/Config'
import * as laundryTimesActions from '../../actions/LaundryTimes'
import * as Functions from '../../../helpers/Functions'

class EditLaundryTimeModal extends Component {
  state = {
    startTimeInput: '',
    endTimeInput: '',
    days: [],
    errorStartTime: '',
    errorEndTime: '',
    errorMessage: ''
  }

  componentWillReceiveProps(nextProps) {
    const { config, laundryTimes } = this.props

    if (
      nextProps.config.editLaundryTimeModal.show &&
      !config.editLaundryTimeModal.show
    ) {
      this.setState({
        startTimeInput: nextProps.laundryTimes.selected.startTime,
        endTimeInput: nextProps.laundryTimes.selected.endTime,
        days: nextProps.laundryTimes.selected.days.split(';'),
        errorEndTime: '',
        errorStartTime: '',
        errorMessage: ''
      })
    }

    if (
      !nextProps.laundryTimes.isUpdating &&
      nextProps.laundryTimes.errorUpdating === null &&
      laundryTimes.isUpdating
    ) {
      this.props.hideEditLaundryTimeModal()
      this.props.showSnackbar(Strings.default.LAUNDRY_TIME_UPDATED)
    } else if (
      !nextProps.laundryTimes.isUpdating &&
      nextProps.laundryTimes.errorUpdating !== null &&
      laundryTimes.isUpdating
    ) {
      this.setState({ errorMessage: Strings.default.INTERNAL_ERROR })
    }
  }

  updateLaundryTime() {
    const { data, user, laundryTimes } = this.props
    const { startTimeInput, endTimeInput, days } = this.state

    this.setState({ errorMessage: '' })

    if (startTimeInput === '') {
      this.setState({ errorStartTime: Strings.default.MANDATORY_FIELD })
    }

    if (endTimeInput === '') {
      this.setState({ errorEndTime: Strings.default.MANDATORY_FIELD })
    }

    if (startTimeInput !== '' && endTimeInput !== '') {
      const postData = {
        startTime: startTimeInput,
        endTime: endTimeInput,
        days: Functions.parseDaysToString(days)
      }

      this.props.tryUpdateLaundryTime(
        user.token,
        data.community.id,
        laundryTimes.selected.id,
        postData
      )
    }
  }

  render() {
    const { config, laundryTimes } = this.props
    const {
      startTimeInput,
      endTimeInput,
      errorStartTime,
      errorEndTime,
      errorMessage,
      days
    } = this.state

    return (
      <TimeModal
        show={config.editLaundryTimeModal.show}
        hide={() => this.props.hideEditLaundryTimeModal()}
        startTimeInput={startTimeInput}
        onChangeStartTimeInput={text =>
          this.setState({
            startTimeInput: text,
            errorStartTime: '',
            errorMessage: ''
          })
        }
        errorStartTime={errorStartTime}
        endTimeInput={endTimeInput}
        onChangeEndTimeInput={text => {
          this.setState({
            endTimeInput: text,
            errorEndTime: '',
            errorMessage: ''
          })
        }}
        errorEndTime={errorEndTime}
        header={Strings.default.EDIT_LAUNDRY_TIME}
        information={Strings.default.EDIT_LAUNDRY_TIME_INFORMATION}
        onDone={() => this.updateLaundryTime()}
        loading={laundryTimes.isUpdating}
        errorMessage={errorMessage}
        days={days}
        onChangeDays={newDays => this.setState({ days: newDays })}
        showDays
      />
    )
  }
}

function mapStateToProps({ config, data, user, laundryTimes }) {
  return { config, data, user, laundryTimes }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...configActions, ...laundryTimesActions },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditLaundryTimeModal)



// WEBPACK FOOTER //
// ./src/components/containers/EditLaundryTimeModal/index.js